var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.items[_vm.examinationTypeID],"hide-details":_vm.shouldHideDetails,"value":_vm.data},on:{"change":function($event){_vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }